// Frontend type definitions

export enum DayOfWeek {
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
  Sunday = 7
}

export enum EventCategory {
  Work = "お仕事",
  HealthBeauty = "健康と美", 
  Hobby = "趣味活動",
  Life = "生活"
}

export interface User {
  id: string;
  name: string;
  availableDays: DayOfWeek[];
  createdAt: Date;
  updatedAt: Date;
}

export interface ScheduledEvent {
  id: string;
  date: Date;
  eventName: string;
  eventType: string;
  eventCategory: EventCategory;
  assignedUserIds: string[]; // User IDs
}

export interface ScheduleTheme {
  id: string;
  name: string;
  primaryColor: string;
  secondaryColor: string;
  backgroundImage?: string;
  headerImage?: string;
  season: 'spring' | 'summer' | 'autumn' | 'winter' | 'custom';
}

export interface MonthlySchedule {
  id: string;
  year: number;
  month: number;
  events: ScheduledEvent[];
  generatedAt: Date;
  theme?: ScheduleTheme;
  customImages?: {
    headerImage?: string;
    backgroundImage?: string;
  };
  imageUsageReport?: {
    headerImage: {
      source: 'uploaded' | 'default' | 'theme';
      isUserUploaded: boolean;
      dataSize: number;
    };
    backgroundImage: {
      source: 'uploaded' | 'default' | 'theme';
      isUserUploaded: boolean;
      dataSize: number;
    };
  };
}

export interface DailyEvent {
  id: string;
  date: Date;
  eventName: string;
  eventType: string;
  eventCategory: EventCategory;
}

export interface HistoricalSchedule {
  id: string;
  year: number;
  month: number;
  events: DailyEvent[];
  uploadedAt: Date;
}